import ProtectedRoute from '@Components/ProtectedRoute';
import { Outlet } from 'react-router-dom';

export default function EventsProtectedLayout() {
  return (
    <ProtectedRoute permissions={['EVENTS_READ']}>
      <Outlet />
    </ProtectedRoute>
  );
}
